import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import rightImgDemo from "images/promo2.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Logo from "shared/Logo/Logo";
import backgroundLineSvg from "images/Moon.svg";
import cover from "images/cover/cover-10.png";
import cover2 from "images/cover/cover-11.png";
import { NavLink } from "react-router-dom";

export interface SectionPromo2Props {
  className?: string;
}

const SectionPromo2: FC<SectionPromo2Props> = ({ className = "lg:pt-10" }) => {
  return (
    
    <div className={`nc-SectionPromo2 ${className}`}>
      <NavLink
    to={{pathname:"/page-collection-2"}}
    >
      <div className="relative flex flex-col lg:flex-row lg:justify-end rounded-2xl sm:rounded-[40px] p-4 pb-0 sm:p-5 sm:pb-0 lg:p-24">
        <div className="absolute inset-0">
          <img
            className="invisible md:visible absolute w-full h-[600px] object-contain dark:opacity-5"
            // src={backgroundLineSvg}
            src={cover}
            alt="backgroundLineSvg"
          />
           <img
            className="visible md:invisible absolute w-full h-full object-cover dark:opacity-5"
            // src={backgroundLineSvg}
            src={cover2}
            alt="backgroundLineSvg"
          />
        </div>

        <div className="lg:w-[800px] max-w-lg h-[220px] md:h-[400px] relative">
          {/* <Logo className="w-28" />
          <h2 className="font-semibold text-2xl sm:text-4xl xl:text-5xl 2xl:text-6xl mt-6 sm:mt-10 !leading-[1.13] tracking-tight">
            Special offer <br />
            in kids products
          </h2>
          <span className="block mt-6 text-slate-500 dark:text-slate-400">
            Fashion is a form of self-expression and autonomy at a particular
            period and place.
          </span>
          <div className="flex space-x-2 sm:space-x-5 mt-6 sm:mt-12">
            <ButtonPrimary
              href="/page-collection-2"
              className="dark:bg-slate-200 dark:text-slate-900"
            >
             Shop Now
            </ButtonPrimary>
          </div> */}
        </div>

        {/* <NcImage
          containerClassName="relative block lg:absolute lg:left-0 lg:bottom-0 mt-10 lg:mt-0 max-w-xl lg:max-w-[calc(55%-40px)]"
          src={rightImgDemo}
        /> */}
      </div>
      </NavLink>
    </div>
    
  );
};

export default SectionPromo2;
